import React from 'react'
import './index.scss'

const CusTomTitle2 = (props) => {
  const {
    title,
    rightText,
    bgColor,
    textClor,
    clickTo,
    id,
    deeplink,
    link,
  } = props
  const getColor = (color) => {
    return color || 'rgba(0,0,0,0.8)'
  }
  return (
    <div
      style={bgColor && { backgroundColor: getColor(bgColor) }}
      onClick={() => clickTo('customTitle', deeplink, link, id)}
      className={`lego_CusTomTitle2Box ${textClor}`}
    >
      <div className="customTitle2left">{title}</div>
      <div className="customTitle2right">
        <span>{rightText}</span>
        <span className="arrawRight">{'>'}</span>
      </div>
    </div>
  )
}

export default CusTomTitle2
